import { CardSection, CardHeader } from '@europrocurement/flexy-components';
import * as React from 'react';
import { PrescriberTabProps } from './types';

const LegalAdvert: React.FunctionComponent<PrescriberTabProps> = function () {
    const cardHeader = (
        <CardHeader
            title="Annonces légales"
            border={false}
        />
    );
    return <CardSection header={cardHeader}>content</CardSection>;
};

export default LegalAdvert;
